//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { EventBus } from '../../../../EventBus/EventBus.js'
import { mapGetters, mapActions } from 'vuex'

import { medicineMain } from './medicine.js'
import MedicalPage from './MedicalPage/MedicalPage.vue'
import MedicalScoreboard from './MedicalScoreboard/MedicalScoreboard.vue'

export default {
  components: {
    MedicalPage,
    MedicalScoreboard
  },
  mixins: [medicineMain],
  props: {
    pageName: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      cometMedicalBlock: null
    }
  },
  computed: {
    ...mapGetters({
      pingResult: 'getPingResult',
      invcometRequest: 'getInvcometRequest'
    })
  },
  watch: {
    pingResult: function (result) {
      if (result.state == 'success' || result.state == 'emptyPage') {
        if (!this.cometMedicalBlock) {
          const isEmpty = Object.keys(this.invcometRequest).length == 0
          this.cometMedicalBlock = isEmpty ? this.setComet() : this.invcometRequest.state
        }
      } else {
        if (this.cometMedicalBlock /* && !this.showInBlock */) {
          this.cometMedicalBlock.unsubscribe()
          this.cometMedicalBlock = null
        }
      }
    },
    pageName: function (name) {
      this.pageUrlName = name
    },
    listWorkShiftMedical: function (workShift) {
      this.setListWorkShiftMedical(workShift)
    },
    timeChangeList: function (time) {
      if (this.$refs.refMedicalPage) {
        this.$refs.refMedicalPage.medicalSchedule = this.medicalSchedule
      } else if (this.$refs.refMedicalScoreboard) {
        this.$refs.refMedicalScoreboard.medicalSchedule = this.medicalSchedule
        this.$refs.refMedicalScoreboard.widthResize = this.widthResize
        this.$refs.refMedicalScoreboard.fontSize = this.fontSize
        this.$refs.refMedicalScoreboard.classResize = this.classResize
      }
    },
    'employeeMedicCheck.time': function (time) {
      const employeeId = this.employeeMedicCheck.employeeId
      if (this.$refs.refMedicalPage) {
        this.$refs.refMedicalPage.onRunMedicalTest({ employeeId: employeeId, id: null })
      }
    }
  },
  beforeDestroy () {
    if (this.cometMedicalBlock && !this.showInBlock) {
      this.cometMedicalBlock.unsubscribe()
      this.cometMedicalBlock = null
    }
  },
  created: function () {
    if (!this.pingResult || !this.pingResult.state || this.pingResult.state == 'empty') {
      this.setPingResult({ state: 'emptyPage' })
    }
    this.pageUrlName = this.pageName
    if (!this.cometMedicalBlock) {
      const isEmpty = Object.keys(this.invcometRequest).length == 0
      this.cometMedicalBlock = isEmpty ? this.setComet() : this.invcometRequest.state
    }
  },
  methods: {
    ...mapActions({ setPingResult: 'setPingResult' }),
    onMedicalRegistrationJournalChanges: function (user) {
      // const that = this
      if (this.$refs.refMedicalPage) {
        const show = this.$refs.refMedicalPage.showMedicalShedule
        if (user.isMedic) {
          this.$refs.refMedicalPage.regularMedicalScheduleStatus().then(function () {
            EventBus.$emit('get-medical-shedule', show)
          })
        } else {
          EventBus.$emit('get-medical-shedule', show)
        }
      } else if (this.$refs.refMedicalScoreboard) {
        const showScoreboard = this.$refs.refMedicalScoreboard.showScoreboardMedicalShedule
        this.$refs.refMedicalScoreboard.fontSize = this.fontSize
        this.$refs.refMedicalScoreboard.widthResize = this.widthResize
        this.$refs.refMedicalScoreboard.getActiveMedical().then(function () {
          EventBus.$emit('get-medical-shedule', showScoreboard)
        })
      }
    },
    setListWorkShiftMedical: function (workShift) {
      if (this.$refs.refMedicalPage) {
        this.$refs.refMedicalPage.listWorkShiftMedical = workShift
      }
      if (this.$refs.refMedicalScoreboard) {
        this.$refs.refMedicalScoreboard.listWorkShiftMedical = workShift
        this.clientWidth = this.$refs.refMedicalScoreboard.$refs.refCardCenterBlock.$el.clientWidth
      }
    }
  }
}

